import React from "react";

const UserManagementUsers = () => {
	return <div>USERS</div>;
};

export default UserManagementUsers;
